import CryptoJS from 'crypto-js'

import api from '@/api'
import { KEY_BARGE_MANAGEMENT_DETAIL_ID } from '@/fixtures/Constants'
import { CRYPTO_KEY } from '@/fixtures/Hash'

const encBargeManagementId = btoa(KEY_BARGE_MANAGEMENT_DETAIL_ID)

const namespaced = true

const state = {
  ownerNames: [],
  bargeManagementId: localStorage.getItem(encBargeManagementId) || null,
  bargeManagements: [],
  bargeManagementDetail: null,
  bargeManagementsFiles: {}
}

const getters = {
  ownerNames: state => state.ownerNames,
  bargeManagementId: state => state.bargeManagementId
    ? Number(CryptoJS.AES.decrypt(state.bargeManagementId, CRYPTO_KEY).toString(CryptoJS.enc.Utf8))
    : null,
  bargeManagements: state => state.bargeManagements,
  bargeManagementDetail: state => state.bargeManagementDetail,
  bargeManagementsFiles: state => state.bargeManagementsFiles
}

const mutations = {
  SET_OWNER_NAMES: (state, payload) => {
    state.ownerNames = payload
  },
  SET_BARGE_MANAGEMENT_ID: (state, payload) => {
    state.bargeManagementId = payload
    localStorage.setItem(encBargeManagementId, payload)
  },
  SET_BARGE_MANAGEMENTS: (state, payload) => {
    state.bargeManagements = payload
  },
  SET_BARGE_MANAGEMENT_DETAIL: (state, payload) => {
    state.bargeManagementDetail = payload
  },
  SET_BARGE_MANAGEMENTS_FILES: (state, payload) => {
    state.bargeManagementsFiles = payload
  }
}

const actions = {
  async fetchOwnerNames({ commit }) {
    try {
      const { data } = await api.getOwnerNames()
      if (data.error) {
        commit('SET_OWNER_NAMES', [])
        return
      }

      commit('SET_OWNER_NAMES', data)
    } catch (err) {
      throw err
    }
  },
  async fetchBargeManagements({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const filter = {
        search: filterConfig.search,
        page: filterConfig.currentPage ?? 1,
        limit: filterConfig.pageSize ?? 10,
        ...payload
      }
      const { data } = await api.getBargeManagements(filter)

      if (data.error) {
        commit('SET_BARGE_MANAGEMENTS', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }

      commit('SET_BARGE_MANAGEMENTS', data.data)
      commit('Table/SET_TOTAL_DATA', data.total, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
    } catch (err) {
      throw err
    }
  },
  async fetchBargeManagementDetail({ commit }, payload) {
    try {
      const { data } = await api.getBargeManagementDetail(payload)

      commit('SET_BARGE_MANAGEMENT_ID', CryptoJS.AES.encrypt(payload.toString(), CRYPTO_KEY).toString())
      if (data.error) {
        commit('SET_BARGE_MANAGEMENT_DETAIL', null)
        return
      }

      commit('SET_BARGE_MANAGEMENT_DETAIL', data)
    } catch (err) {
      throw err
    }
  },
  async postBargeManagement({}, payload) {
    try {
      await api.postBargeManagement(payload)
    } catch ({ data }) {
      throw data
    }
  },
  async putBargeManagement({}, payload) {
    try {
      await api.putBargeManagement(payload.id, payload.form)
    } catch ({ data }) {
      throw data
    }
  },
  async deleteBargeManagement({}, payload) {
    try {
      await api.deleteBargeManagement(payload)
    } catch (err) {
      throw err
    }
  },
  async downloadBargeManagements({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const response = await api.getBargeManagementsExcelDownload({
        search: filterConfig.search,
        ...payload})
      if (response) {
        commit('SET_BARGE_MANAGEMENTS_FILES', response)
      }
    } catch (err) {
      throw err
    }
  },
  resetBargeManagementsFiles({ commit }) {
    commit('SET_BARGE_MANAGEMENTS_FILES', {})
  },
  async fetchBargeManagementsUnpaginated({ commit }, payload) {
    try {
      const { data } = await api.getBargeManagements(payload)

      if (data.error) {
        commit('SET_BARGE_MANAGEMENTS', [])
        return
      }

      commit('SET_BARGE_MANAGEMENTS', data)
    } catch (err) {
      throw err
    }
  }
}

export default { namespaced, state, getters, mutations, actions }
